module.exports = __webpack_public_path__ + "src/app/assets/images/clubSviluppatori.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/images/clubSviluppatori.png
// module id = 629
// module chunks = 0